module.exports = __webpack_public_path__ + "media/images/phone_desktop-c1d670ab.svg";